import styled from 'styled-components'
import { COLORS, SHADOWS } from 'tokens'

// Each section gets its width & min-width from parent component
export const Column = styled.div`
  width: 15%;
  min-width: 180px;
  max-height: 851px;
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
`

export const DatePanel = styled.div`
  min-width: 140px;
  background: ${COLORS.background};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DateHeader = styled.div`
  text-align: center;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 6px;
  background: ${COLORS.background};
  border: 1px solid ${COLORS.borderPrimary};
  font-weight: 700;
  color: ${COLORS.textPrimary};
`

export const DateItem = styled.div<{ $isSelected?: boolean }>`
  width: 100%;
  padding: 10px;
  background: ${COLORS.background};
  outline: 1px solid ${(props) => (props.$isSelected ? COLORS.borderPrimary : 'none')};
  outline-offset: '-1px';
  box-shadow: ${SHADOWS.boxShadow};
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: ${COLORS.textPrimary};
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;
`
